import { message, Button, Modal } from "antd";
import React from "react";

const ShareWithOwners = ({ isModalVisible, handleCancel, handleOk }) => {
  const handleShare = () => {
    message.success(
      `This inspection was successfully shared to the Owner Portal.`
    );
  };
  return (
    <div>
      <Modal
        title="Share Inspection with Owners?"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleShare}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Button onClick={handleShare} type="primary">
                Share
              </Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
            <div></div>
          </div>
        }
      >
        <p style={{ fontSize: "12px" }}>
          You are about to publish a snapshot of this inspection to the owner
          portal. Owners associated with this inspection will receive an email
          notification.
        </p>
        <br />
        <b>Currently, inspections cannot be unshared.</b>
      </Modal>
    </div>
  );
};

export default ShareWithOwners;
